<lc-base-dialog primaryAction="Ok" subheader="View your QR statistics" title="QR Scans" (actionClicked)="onClose()">

  <ng-template #content>
    <lc-qr-statistics-table [marketingOrderId]="marketingOrderId" />
  </ng-template>
</lc-base-dialog>

